<div>
    <mat-form-field class="field-full-width" appearance="legacy">
        <mat-label>Nom du vaccin</mat-label>
        <input matInput placeholder="vaccin" [(ngModel)]="vaccine.value">
    </mat-form-field>
</div>
<div>
    <app-vaccine-diseases [vaccine]="vaccine"></app-vaccine-diseases>
</div>
